
<ng-template  [ngIf]="listItem.url">
  <ion-item detail="false" (click)="go(listItem.url, {'listIndex': listIndex})" [style.cursor]="listItem.url ? 'pointer': 'none'" *ngIf="listItem.content || listItem.label" [ngClass]="listItem.class">
    <ion-label>
      <h2 [innerHTML]="listItem.label | multiLang | safe: 'html'"></h2>

      <ng-template [ngIf]="listItem.content">
        <ion-text class="ql-editor" [innerHTML]="listItem.content | multiLang | shortCode | safe: 'html'">

        </ion-text>
      </ng-template>

    </ion-label>
    <fa-icon [icon]="listItem.icon ? listItem.icon : ['fas', 'chevron-right'] " slot="end"></fa-icon>
  </ion-item>
</ng-template>


<ng-template [ngIf]="!listItem.url">
  <ion-item detail="false"  *ngIf="listItem.content || listItem.label" [ngClass]="listItem.class">
    <ion-label>
      <h2 [innerHTML]="listItem.label | multiLang | safe: 'html'"></h2>

      <ng-template [ngIf]="listItem.content">
        <ion-text class="ql-editor" [innerHTML]="listItem.content | multiLang | shortCode | safe: 'html'">

        </ion-text>
      </ng-template>

    </ion-label>
  </ion-item>

</ng-template>



<ng-template [ngIf]="listItem.controls && listItem.controls.length > 0">
    <app-list [list]="listItem.controls" [config]="listItem.controls[0].config?listItem.controls[0].config : listConfig " [level]="(level+1)" style="width: 100%" [listIndex]="listIndex"></app-list>
</ng-template>
